module.exports = __webpack_public_path__ + "static/media/07.c5e0d6ca.jpg";